export const DOCUMENT_IMPORT_SOURCE = { YARDI: "YARDI" };
